import { LoanCentricMobileDockIds } from "./loanCentricMobileDockIds";

export interface GetLoanCentricMobileDockActiveTabParams {
  readonly pathname: string;
}

/**
 * Resolves which dock tab is selected.
 * /home → Home; /my-loans → Loans; /settings → Settings;
 * loan dashboard (and other loan-context) → Loans.
 */
export function getLoanCentricMobileDockActiveTab({
  pathname,
}: GetLoanCentricMobileDockActiveTabParams): LoanCentricMobileDockIds {
  if (pathname === "/home") {
    return LoanCentricMobileDockIds.Home;
  }

  if (pathname === "/my-loans") {
    return LoanCentricMobileDockIds.Loans;
  }

  if (pathname === "/settings") {
    return LoanCentricMobileDockIds.Settings;
  }

  // Dashboard and other loan-context routes: prefer Loans (user came from loans list).
  return LoanCentricMobileDockIds.Loans;
}
